// extracted by mini-css-extract-plugin
export var container1 = "services-module--container1--uW4dp";
export var container2 = "services-module--container2--1vl9r";
export var reverse = "services-module--reverse--3qfiZ";
export var container3 = "services-module--container3---7Da7";
export var services = "services-module--services--2L6F5";
export var servicesNames = "services-module--servicesNames--33EI0";
export var icon = "services-module--icon--58ROR";
export var image = "services-module--image--1YZvU";